import {action} from 'typesafe-actions'
import {Resources} from '@models/resources'
import {RequestData} from "@models/axios";


export const enum ResourcesActionTypes {
    FETCH_REQUEST = '@@Resources/FETCH_REQUEST',
    FETCH_SUCCESS = '@@Resources/FETCH_SUCCESS',
    FETCH_ERROR = '@@Resources/FETCH_ERROR',

    DELETE_REQUEST = '@@Resources/DELETE_REQUEST',
    DELETE_SUCCESS = '@@Resources/DELETE_SUCCESS',
    DELETE_ERROR = '@@Resources/DELETE_ERROR',

}


export const fetchRequest = (data: RequestData) => action(ResourcesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Resources[]) => action(ResourcesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(ResourcesActionTypes.FETCH_ERROR, message);


export const deleteRequest = (data: RequestData) => action(ResourcesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data: RequestData) => action(ResourcesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(ResourcesActionTypes.DELETE_ERROR, message);


